module.exports = __webpack_public_path__ + "static/media/housing_gateway.cc00198a.svg";